<template>
  <div>
    <PageMain
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openEditFromDialog="openEditFromDialog"
      @reload="reload"
      @openUploadFormDialog="() => (uploadFormDialogVisible = true)"
      @batchDel="submitDel"
    >
      <PageHeader
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openUploadFormDialog="() => (uploadFormDialogVisible = true)"
        @batchDel="batchDel"
      />
    </PageMain>

    <UploadFormDialog
      :title="$l('INDEX.dialog_title_shipment_upload_doc') || '上传发运单文件'"
      :visible.sync="uploadFormDialogVisible"
      :shipmentCode="shipmentCode"
      @reload="reload"
    />

    <EditFromDialog
      :title="editFromDialogOption.title"
      :visible.sync="editFromDialogOption.visible"
      :shipmentDocCode="editFromDialogOption.code"
      :disabled="editFromDialogOption.disabled"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import UploadFormDialog from '../upload-form/dialog.vue'
import EditFromDialog from '../edit-form/dialog.vue'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, UploadFormDialog, EditFromDialog },
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      uploadFormDialogVisible: false,
      editFromDialogOption: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      if (!this.shipmentCode) return
      this.loading = true
      this.$api
        .shipmentDocListApi({ ...form, shipmentCode: this.shipmentCode })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFromDialog({ type, code }) {
      const types = {
        detail:
          this.$l('INDEX.dialog_title_shipment_detail_doc') ||
          '发运单文档详情信息',
        edit:
          this.$l('INDEX.dialog_title_shipment_edit_doc') ||
          '编辑发运单文档信息',
      }

      this.editFromDialogOption = {
        visible: true,
        code,
        title: types[type],
        disabled: type === 'detail',
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords('code')
      if (!listCode) return
      this.submitDel(listCode)
    },
    submitDel(listCode) {
      if (!listCode || !listCode.length) return
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .shipmentDocDelApi({ listCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.reload()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
  },
}
</script>
